import { Pipe, PipeTransform } from '@angular/core';
import { sortBy } from 'lodash';

@Pipe({
  name: 'groupBy',
  pure: false
})
// This will actually group AND sort
// To sort, pass in the optional parameter
export class GroupByPipe implements PipeTransform {
  transform(value: any, groupByKey: string, sort?: boolean) {
    const events: any[] = [];
    const groupedElements: any = {};

    if (!value) return;

    value.forEach((obj: any) => {
      if (!(obj[groupByKey] in groupedElements)) {
        groupedElements[obj[groupByKey]] = [];
      }
      groupedElements[obj[groupByKey]].push(obj);
    });

    for (let prop in groupedElements) {
      if (groupedElements.hasOwnProperty(prop)) {
        events.push({
          key: prop,
          list: groupedElements[prop]
        });
      }
    }  
    
    return events;
    
    // return sort ? (
    //   sortBy(events, 'key')
    // ) : events;
  }
}
